<script setup>
const goChatbot = (page) => {
  if (typeof window === "undefined") return;

  if (typeof gtag !== "undefined") {
    gtag("event", "Index_click", {
      action: "goChatbot",
      page: page || "home",
    });
  }
  if (localStorage.utm_ref != null) {
    window.open(
      "https://chatxbuy-springboard.web.app?ref=" + localStorage.utm_ref,
    );
  } else {
    window.open("https://chatxbuy-springboard.web.app");
  }
};
</script>

<template>
  <section class="hero-section">
    <div class="gradient-layer">
      <!-- Mobile Content -->
      <div class="hero-content-mobile">
        <p class="hero-title-mo">代買幫 CHATxBUY</p>
        <p class="hero-title2-mo">專業阿里巴巴 1688 代買</p>
        <p class="hero-desc-mo">
          從下單、賣家溝通、國際集運到商品抵達，<br />代買幫都幫您 一手包辦。<br />讓您可以享受無憂的
          1688 代買體驗！
        </p>
      </div>

      <!-- Desktop Content -->
      <div class="hero-content-desktop">
        <div class="hero-title">代買幫 CHATxBUY</div>
        <div class="hero-title2">專業阿里巴巴 1688 代買</div>
        <div class="hero-content">
          從下單、賣家溝通、國際集運到商品抵達，代買幫都幫您<br />
          一手包辦。讓您可以享受無憂的 1688 代買體驗！
        </div>
      </div>

      <!-- Images -->
      <img
        class="global-mo"
        src="@/assets/images/mobile/hero/Group_3913.svg"
        alt="代買幫"
      />

      <picture>
        <source
          media="(min-width: 1060px)"
          srcset="@/assets/images/desktop/hero/Vector.svg"
        />
        <img
          class="transparent-bg"
          style="display: none"
          src="@/assets/images/desktop/hero/Vector.svg"
          alt="漸層白底"
        />
      </picture>
      <img
        class="transparent-bg-desktop"
        src="@/assets/images/desktop/hero/Vector.svg"
        alt="漸層白底"
      />

      <img
        class="transparent-bg2"
        src="@/assets/images/desktop/hero/image_12.svg"
        alt="代買幫"
      />
      <img
        class="key-visual"
        src="@/assets/images/desktop/hero/Group_3859.svg"
        alt="代買幫"
      />

      <img
        class="transparent-bg3"
        @click="goChatbot('hero')"
        src="@/assets/images/desktop/hero/Frame_624684.png"
        alt="代買幫"
      />

      <img
        class="transparent-down"
        src="@/assets/images/desktop/hero/Group.svg"
        alt="下圓弧"
      />
    </div>
  </section>
</template>

<style scoped>
/* Hero Section */
.gradient-layer {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
  background: linear-gradient(to bottom right, #91acf9, #3c5bff);
  width: 100%;
  height: 660px;
  position: relative;
  overflow: hidden;
}

.hero-content-desktop {
  display: none;
}

.hero-title-mo {
  font-weight: bold;
  font-size: 30px;
  margin-top: 50px;
}

.hero-title2-mo {
  font-weight: bold;
  color: #ffffff;
  font-size: 20px;
  margin-top: 19px;
}

.hero-desc-mo {
  font-weight: 500;
  color: #ffffff;
  font-size: 16px;
  height: auto;
  margin-top: 24px;
}

.global-mo {
  margin-top: 27px;
  margin-left: 30px;
  margin-bottom: 28px;
}

.transparent-bg-desktop,
.transparent-bg2,
.transparent-down,
.key-visual {
  display: none;
}

.transparent-bg3 {
  display: block;
  width: 220px;
  position: absolute;
  top: 575px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
}

@media (min-width: 1060px) {
  .gradient-layer {
    height: 42.474vw;
  }

  .hero-content-mobile {
    display: none;
  }

  .hero-content-desktop {
    display: block;
  }

  .transparent-bg-desktop {
    display: block;
    position: absolute;
    right: 0px;
    top: 5%;
    width: 60vw;
  }

  .transparent-bg2 {
    display: block;
    width: 10vw;
    height: auto;
    position: absolute;
    left: 5%;
    top: 10%;
  }

  .key-visual {
    display: block;
    width: 53vw;
    height: auto;
    position: absolute;
    left: 44%;
    top: 8%;
  }

  .transparent-down {
    display: block;
    height: auto;
    position: absolute;
    top: auto;
    bottom: 0px;
    width: 100%;
    left: 0;
    transform: none;
  }

  .transparent-bg3 {
    width: 18vw;
    left: 11.5vw;
    top: 27vw;
    transform: none;
  }

  .global-mo {
    display: none;
  }

  .hero-title {
    font-weight: bold;
    font-size: 3vw;
    position: absolute;
    top: 9.5vw;
    left: 11.5vw;
    transform: scaleY(1.07);
  }

  .hero-title2 {
    font-weight: bold;
    color: #ffffff;
    font-size: 2.1vw;
    height: auto;
    position: absolute;
    top: 14.5vw;
    left: 11.5vw;
  }

  .hero-content {
    font-weight: Medium;
    color: #ffffff;
    font-size: 1.3vw;
    height: auto;
    position: absolute;
    top: 19vw;
    left: 11.5vw;
    line-height: 2.2vw;
  }
}
</style>
